<script>
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { themeMixin } from '@mixins/theme-mixin';

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_KEY,
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
  appVersion: process.env.VUE_APP_VERSION,
  enabledReleaseStages: ['production', 'development'],
});

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title
        ? `${title} | ${this.$store.getters['organization/organizationTitle']}`
        : this.$store.getters['organization/organizationTitle'];
    },
  },
  mixins: [themeMixin],
};
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>
